module.exports = __webpack_public_path__ + "static/media/promo-code-icon.5a14d83c.svg";